import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios";
import type { ApiResponse } from "./ApiResponse";
import { onboardingEndPoints } from "../urlConfig/apiEndpoints";
import { executeLogout } from "@/app/utils/loginFlow/logoutHelper";
import { store, type RootState } from "@/app/redux/store";
import { extractErrorMessage } from "../errorservices/errorservices";
import {
  CORRELATION_ID_HEADER,
  generateCorrelationId,
} from "@/app/utils/loginFlow/correlationId";

type MethodType = "get" | "post" | "put" | "delete";

interface ApiRequestConfig {
  method: MethodType;
  url: string;
  payload?: Record<string, any>;
  token?: string;
}

const getTenantId = (): string | undefined => {
  const state = store.getState() as RootState;
  return state.userData?.data?.tenantId;
};

// ---------------- Auth logout registration ----------------
const handleUnauthorized = (err: any) => {
  executeLogout();
  return Promise.reject(err);
};

export const handleApiRequest = async <T>({
  method,
  url,
  payload = {},
  token = "",
}: ApiRequestConfig): Promise<ApiResponse<T>> => {
  try {
    const tenantId = getTenantId();
    const correlationId = generateCorrelationId();
    const headers: Record<string, string | undefined> = {
      Accept: "*/*",
      appId: tenantId,
      [CORRELATION_ID_HEADER]: correlationId,
      "Content-Type":
        payload instanceof FormData ? undefined : "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const config: AxiosRequestConfig = { headers };

    let response: AxiosResponse<ApiResponse<T>>;

    if (method === "get" || method === "delete") {
      response = await axios[method](url, { ...config, params: payload });
    } else {
      response = await axios[method](url, payload, config);
    }

    return response.data;
  } catch (error: any) {
    const { code } = extractErrorMessage(error);

    if (code === 401) {
      return handleUnauthorized(error);
    }

    throw error?.response?.data || error;
  }
};

export const growxsettings = (token: string) => {
  return handleApiRequest<any>({
    method: "get",
    url: onboardingEndPoints.growxsettings,
    token,
  });
};
